import { Switch, Route } from "react-router-dom";
import { TestStatusMain } from "./routes/test-status";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getListItemsWithListType } from "utils/metadata-split/metaDataApiFetch";

export function TestStatus({ match }: { match: any }) {
    const [showLoading, setShowIsLoading] = useState(true);
      const dispatch = useAppDispatch();
    
      const { isLoading, data: metaData }: any = useAppSelector(
        (state) => state.metadataReducer
      );
    const updateMetaData = (listData, metaKey) => {
        let metadataList = { ...metaData };
        metadataList[metaKey] = listData;
        dispatch(metadataSuccess(metadataList));
        setShowIsLoading(false);
      };
    
      useEffect(() => {
        (async () => {
          try {
            const call1:any=await getListItemsWithListType("institution_list","institution_list");
            updateMetaData(call1[0], call1[1]);
          } catch (error) {
          }
        })();
      }, []);
    
      if (showLoading) {
        return <p>Loading institutions data....</p>;
      }
  
  return (
    <>
      <Switch>
        <Route exact path={`${match.url}`} component={TestStatusMain} />
      </Switch>
    </>
  );
}
